var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:[
    'badge',
    'text-white',
    _vm.statuses[_vm.order.operation_id][_vm.order.status].class,
  ],staticStyle:{"line-height":"1.2"}},[_vm._v("\n  "+_vm._s(_vm.statuses[_vm.order.operation_id][_vm.order.status].text)+"\n  "+_vm._s(_vm.order.number))])
}
var staticRenderFns = []

export { render, staticRenderFns }